import { render, staticRenderFns } from "./NewsCategoryInfo.vue?vue&type=template&id=f676d82e&scoped=true&"
import script from "./NewsCategoryInfo.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f676d82e",
  null
  
)

export default component.exports